export type Tab = "all" | "voucher";

export interface Question {
  id: number;
  question: string;
  answer: string;
}

export const allQuestions: Question[] = [
  {
    id: 1,
    question: "O Clique Médicos é um Plano de Saúde?",
    answer:
      "Não, o Clique Médicos não é um plano de saúde, não possui carência e nem mensalidades.",
  },
  {
    id: 2,
    question: "O que posso comprar no site do Clique Médicos?",
    answer:
      "No site do Clique Médicos você poderá adquirir consultas, exames, procedimentos e sessões de Fisioterapia, Fonoaudiologia e Psicologia.",
  },
  {
    id: 3,
    question:
      "Como são realizadas as marcações de consultas, procedimentos e exames?",
    answer:
      "As marcações são realizadas pela equipe do Marque Aqui, da AMHP, após a efetivação da compra. A equipe utilizará os dados informados para realizar a marcação e ao realizar a marcação encaminhará ao usuário mais informações sobre o agendamento. Lembrando que o dados informados são meramente sugestões, dependendo da disponibilidade da clínica e profissional para o dia e horário solicitados.",
  },
  {
    id: 4,
    question: "Preciso pagar outros valores na Clínica?",
    answer:
      "Não. O pagamento da consulta, do procedimento, do exame ou da sessão é feito diretamente no site, no ato da compra, não devendo ser cobrado nenhum outro valor.",
  },
  {
    id: 5,
    question: "O Clique Médicos possui aplicativo?",
    answer:
      "O Clique Médicos não possui aplicativo para celular. Entretanto, é responsível a todos os celulares quando acessado pelo navegador por meio do site: www.cliquemedicos.com.br.",
  },
  {
    id: 6,
    question: "Como faço para agendar exames, procedimentos e sessões?",
    answer:
      "Para exames, procedimentos e sessões o usuário poderá agendar o serviço diretamente na clínica. Caso tenha dificuldade no agendamento, poderá entrar em contato com a equipe do Marque Aqui (3445-5050) para apoiá-lo no referido agendamento.",
  },
  {
    id: 7,
    question: "A Clínica emitirá a Nota Fiscal?",
    answer:
      "Sim, a clínica emitirá a nota fiscal em nome do comprador. O valor da nota fiscal será o mesmo valor do vale.",
  },
  {
    id: 8,
    question:
      "Efetuei a compra por boleto bancário, posso realizar a consulta no mesmo dia?",
    answer:
      "As compras adquiridas por boleto bancário só poderão ser utilizados após o processamento da compensação do pagamento que dura de um a três dias que o boleto for quitado.",
  },
  {
    id: 9,
    question: "Como funciona o retorno da consulta?",
    answer:
      "O paciente tem direito a 01 (um) retorno em até 30 dias após a realização da consulta médica. Para a especialidade de Psiquiatria e para serviços que possuem sessões de Fisioterapia, Fonoaudiologia, Psicologia e Reeducação Postural Global (RPG), não há retorno.",
  },
  {
    id: 10,
    question: "Nos casos de exames, preciso apresentar o pedido médico?",
    answer:
      "Sim, para a realização do exame é necessária a apresentação do pedido médico.",
  },
];

export const voucherQuestions: Question[] = [
  {
    id: 1,
    question: "Preciso imprimir o vale-compra para apresentá-lo na clínica?",
    answer:
      "Não será necessário imprimir o vale-compra. Você vai receber o vale por e-mail e poderá apresentá-lo na Clínica, sem a necessidade da levá-lo impresso.",
  },
  {
    id: 2,
    question: "Posso parcelar a compra do vale?",
    answer:
      "Sim, você pode parcelar a compra do vale em até 12 vezes com juros próprios do cartão de crédito. As compras por meio de boleto não permitem o parcelamento.",
  },
  {
    id: 3,
    question: "Qual o prazo do vale-compra?",
    answer:
      "O vale-compra tem validade de 30 dias, a partir do agendamento da consulta.",
  },
];
